import { render, staticRenderFns } from "./wechatEdit.vue?vue&type=template&id=2201e59a&scoped=true"
import script from "./wechatEdit.vue?vue&type=script&lang=js"
export * from "./wechatEdit.vue?vue&type=script&lang=js"
import style0 from "./wechatEdit.vue?vue&type=style&index=0&id=2201e59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201e59a",
  null
  
)

export default component.exports